class ProductCardGallery extends window.MediaQueryController {
  static values = {
    sectionId: String,
    small: Number,
    medium: Number,
    large: Number,
    xlarge: Number,
  };

  slidesPerView = {
    small: this.smallValue,
    medium: this.mediumValue,
    large: this.largeValue,
    xlarge: this.largeValue,
  };

  connect() {
    super.connect();

    this.swiper = new Swiper(
      `.product-card-gallery-swiper-container-${this.sectionIdValue}`,
      {
        spaceBetween: 10,
        slidesPerView: "auto",
        loop: true,
        navigation: {
          nextEl: `.swiper-button-next-${this.sectionIdValue}`,
          prevEl: `.swiper-button-prev-${this.sectionIdValue}`,
        },
        pagination: {
          el: `.swiper-pagination-${this.sectionIdValue}`,
          bulletClass:
            "swiper-pagination-bullet tw-border tw-border-blue-700 tw-bg-transparent tw-opacity-100",
          bulletActiveClass: "!tw-bg-blue-700",
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: this.slidesPerView["small"],
          },
          640: {
            slidesPerView: this.slidesPerView["medium"],
          },
          1024: {
            slidesPerView: this.slidesPerView["large"],
          },
          1280: {
            slidesPerView: this.slidesPerView["xlarge"],
          },
        },
      },
    );
  }
}

Stimulus.register("productCardGallery", ProductCardGallery);
